import {useEffect} from 'react'
import {FacilityEditModalHeader} from './FacilitieEditModalHeader'
import {FacilityEditModalFormWrapper} from './FacilitieEditModalFormWrapper'

const FacilityEditModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_Facility'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered modal-dialog-scrollable mw-500px'>
        {/* begin::Modal content */}
          <div className='modal-content border-0 rounded-4 shadow-lg overflow-hidden'>
            <FacilityEditModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y px-8 py-6'>
              <FacilityEditModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show' style={{backgroundColor: 'rgba(15, 23, 42, 0.45)'}}></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {FacilityEditModal}
